import {
  NOT
} from '../../../../lib/Boolean.lib';
import Core from '../../../../lib/Core';
import Definition, {
  DEFINITION_CATEGORY__TECHNICAL_SKILLS
} from '../../../../lib/Definition';
import fetchResumeHighlightsNonComplexTasksList from '../../../../lib/services/Configurations/fetchResumeHighlightsNonComplexTasksList.fun';
import {
  fetchTagIdEmployerSkills
} from './EmployerSkills.lib';
import getTagIdsTechSkillsRelevant from './getTagIdsTechSkillsRelevant.fun';
import {
  fetchTagIdJobSkills
} from './JobSkills.lib';

export default async function getCandidateResumePdfAnnotations({
  jobId = '',
  employerId = ''
}) {
  const annotations = [];
  const jobSkillIds = await fetchTagIdJobSkills({ jobId });
  const employerSkillIds = await fetchTagIdEmployerSkills({ employerId });
  const groupSkillIds = getTagIdsTechSkillsRelevant();

  const jobKeywords = Definition.getLabels(
    DEFINITION_CATEGORY__TECHNICAL_SKILLS,
    jobSkillIds
  );

  const employerKeywords = Definition.getLabels(
    DEFINITION_CATEGORY__TECHNICAL_SKILLS,
    employerSkillIds
  ).filter(
    (keyword) => !jobKeywords.includes(keyword)
  );

  const otherKeywords = Definition.getLabels(
    DEFINITION_CATEGORY__TECHNICAL_SKILLS,
    groupSkillIds
  ).filter(
    (keyword) => !jobKeywords.includes(keyword) && !employerKeywords.includes(keyword)
  );

  // JOB skills
  annotations.push({
    keywords: jobKeywords,
    action: 'highlight',
    intensity: 'light',
    color: 'red'
  });

  // EMPLOYER skills minus JOB skills
  annotations.push({
    keywords: employerKeywords,
    action: 'highlight',
    intensity: 'light',
    color: 'yellow'
  });

  // GROUP skills minus JOB AND EMPLOYER SKILLS
  annotations.push({
    keywords: otherKeywords,
    action: 'highlight',
    intensity: 'light',
    color: 'green'
  });

  if (NOT(Core.isEmployer())) {
    const nonComplexTasksList = await fetchResumeHighlightsNonComplexTasksList();
    annotations.push({
      keywords: nonComplexTasksList,
      action: 'highlight',
      intensity: 'light',
      color: 'blue'
    });
  }

  return annotations;
}
